import { useEffect, useMemo } from "react";
import { Book } from "types";
import { createFirestoreDoc } from "~/clients/firebase/client";
import { useGlobalState } from "~/state";


interface Props {
  book: Book;
}
export default function useRecentViews({ book }: Props) {

  const { state } = useGlobalState()
  const uid = useMemo(() => state?.user?.data?.uid, [state?.user])

  useEffect(() => {
    let mounted = true
    if (!mounted || !book?.id || !uid) return

    if (book.seller_id === uid) return

    createFirestoreDoc(
      `users/${uid}/recent_views`,
      {
        ...book,
        time_viewed: new Date(),
        book_id: book.id // needed for backwards compatibility. The app currently depends on this field
      },
      book.id,
    )
    return () => {
      mounted = false
    }
  }, [book, uid])

  return null
}
